import script from "./uploadPic.vue?vue&type=script&lang=ts&setup=true"
export * from "./uploadPic.vue?vue&type=script&lang=ts&setup=true"

import "./uploadPic.vue?vue&type=style&index=0&id=479300bc&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-479300bc"]])

export default __exports__